import { render } from "./DetailsUser.vue?vue&type=template&id=1bfc8420"
import script from "./DetailsUser.vue?vue&type=script&lang=js"
export * from "./DetailsUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__